<!-- <ng-scrollbar externalViewport appearance="compact" visibility="hover"> -->
<div [ngStyle]="{ height: 'calc(100vh - 84px)' }" class="flex flex-col justify-between p-4">
  <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
    @for (nav of menuList(); track $index) {
      @if (nav.subMenuList && nav.subMenuList.length > 0) {
        <li
          nz-submenu
          [nzTitle]="titleTemplate"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? nav.name : ''"
        >
          <ng-template #titleTemplate>
            <a class="flex gap-3 items-center min-w-10 min-h-10">
              <svg-icon [src]="nav.icon" [svgStyle]="{ 'width.px': 16, height: 'auto' }"></svg-icon>
              <span>{{ nav.name }}</span>
            </a>
          </ng-template>

          <ul>
            @for (item of nav.subMenuList; track $index) {
              <li nz-menu-item [nzMatchRouterExact]="item.exact" nzMatchRouter>
                <a [routerLink]="item.link" class="flex gap-3 items-center min-w-10 min-h-10">
                  <svg-icon
                    [src]="item.icon"
                    [svgStyle]="{ 'width.px': 16, height: 'auto' }"
                  ></svg-icon>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      } @else {
        <li
          nz-menu-item
          [nzDanger]="nav.type === 'Danger'"
          [nzMatchRouterExact]="nav.exact"
          nzMatchRouter
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? nav.name : ''"
        >
          <a [routerLink]="nav.link" class="flex gap-3 items-center min-w-10 min-h-10">
            <svg-icon [src]="nav.icon" [svgStyle]="{ 'width.px': 16, height: 'auto' }"></svg-icon>
            <span>{{ nav.name }}</span>
          </a>
        </li>
      }
    }
  </ul>

  <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
    @for (nav of menuList2(); track $index) {
      @if (nav.subMenuList && nav.subMenuList.length > 0) {
        <li
          nz-submenu
          [nzTitle]="titleTemplate"
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? nav.name : ''"
        >
          <ng-template #titleTemplate>
            <a class="flex gap-3 items-center min-w-10 min-h-10">
              <svg-icon [src]="nav.icon" [svgStyle]="{ 'width.px': 16, height: 'auto' }"></svg-icon>
              <span>{{ nav.name }}</span>
            </a>
          </ng-template>

          <ul>
            @for (item of nav.subMenuList; track $index) {
              <li nz-menu-item [nzMatchRouterExact]="item.exact" nzMatchRouter>
                <a [routerLink]="item.link" class="flex gap-3 items-center min-w-10 min-h-10">
                  <svg-icon
                    [src]="item.icon"
                    [svgStyle]="{ 'width.px': 16, height: 'auto' }"
                  ></svg-icon>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      } @else {
        <li
          nz-menu-item
          [nzDanger]="nav.type === 'Danger'"
          [nzMatchRouterExact]="nav.exact"
          nzMatchRouter
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? nav.name : ''"
        >
          <a [routerLink]="nav.link" class="flex gap-3 items-center min-w-10 min-h-10">
            <svg-icon [src]="nav.icon" [svgStyle]="{ 'width.px': 16, height: 'auto' }"></svg-icon>
            <span>{{ nav.name }}</span>
          </a>
        </li>
      }
    }
  </ul>
</div>
<!-- </ng-scrollbar> -->
